module.exports = __webpack_public_path__ + "img/dianchi-20.ac571333.png";